<template>
  <ui-popover :open="isOpen" @update:open="(value) => isOpen = value">
    <ui-popover-trigger as-child>
      <button
        type="button"
        data-slot="distance-radius"
        :disabled="disabled"
        class="shrink-0 cursor-pointer rounded-md px-2 py-1 text-sm font-medium text-primary hover:bg-primary/10 disabled:cursor-not-allowed disabled:opacity-50"
      >
        + {{ modelValue }} km
      </button>
    </ui-popover-trigger>
    <ui-popover-content align="end" class="flex w-72 flex-col gap-3">
      <div class="flex items-center gap-3 text-xs text-muted-foreground">
        <span>{{ min }}</span>
        <ui-slider
          :model-value="[ Number(modelValue) ]"
          :min="min"
          :max="max"
          :aria-label="tr('Radius')"
          @update:model-value="(value) => emitValue(value[0])"
        />
        <span>{{ max }}</span>
      </div>
      <div class="flex items-center gap-2">
        <number-input
          class="w-24"
          :model-value="modelValue"
          :step="1"
          :min="min"
          :max="max"
          @update:model-value="(value) => emitValue(value)"
        />
        <span class="text-sm text-muted-foreground">km</span>
      </div>
    </ui-popover-content>
  </ui-popover>
</template>

<script>
import NumberInput from '@/ui/components/NumberInput.vue';

/** "+ N km" radius chip of a location; opens a slider and a number field. */
export default {
  name: 'DistanceRadiusSelector',
  components: {
    NumberInput,
  },
  props: {
    modelValue: {
      type: Number,
      required: true,
    },
    min: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  emits: [ 'update:modelValue' ],
  data: () => ({
    isOpen: false,
  }),
  methods: {
    emitValue(value) {
      const number = parseInt(value);
      if (!isNaN(number)) {
        this.$emit('update:modelValue', number);
      }
    },
  },
};
</script>
